var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg94(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5606 45.4394L34.3015 32.1803C37.2286 28.7685 38.9998 24.3374 38.9998 19.5C38.9999 8.74772 30.2523 0 19.5 0C8.74772 0 0 8.74772 0 19.5C0 30.2523 8.74772 39 19.5 39C24.3374 39 28.7684 37.2287 32.1803 34.3016L45.4394 47.5607C45.7323 47.8536 46.1161 48 46.5 48C46.8839 48 47.2677 47.8536 47.5606 47.5606C48.1464 46.9748 48.1464 46.0252 47.5606 45.4394ZM19.5 36C10.4018 36 3 28.5982 3 19.5C3 10.4018 10.4018 3 19.5 3C28.5981 3 35.9999 10.4018 35.9999 19.5C35.9999 28.5982 28.5981 36 19.5 36Z",
    fill: "#DB2A12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg94);
export default __webpack_public_path__ + "static/media/svg94.6a928b0ad96920fc0f4014ec60e1e631.svg";
export { ForwardRef as ReactComponent };